<template>
    <v-dialog width="700px" v-model="dialog">

        <template v-slot:activator="{ on }" class="primary">
            <v-btn
                    class="primary"
                    text
                    v-on="on"
            ><v-icon left>mdi-plus</v-icon>Add Restaurant
            </v-btn>
        </template>

        <v-card>
            <v-card-title>
                <span class="headline">Add a New Restaurant</span>
                <div class="dialog-closeBtn" @click="dialog = false"><v-icon left>mdi-close</v-icon></div>
            </v-card-title>
            <v-card-text>
                <v-container class="pl-0 pr-0">
                    <v-tabs
                        v-model="tab_edit_restaurant"
                        background-color="grey lighten-4"
                        fixed-tabs
                        slider-color="grey darken-1"
                        style="margin-bottom:16px"
                    >
                        <v-tab>Main</v-tab>
                        <v-tab>Additional</v-tab>
                    </v-tabs>

                    <v-form ref="form">
                        <v-tabs-items v-model="tab_edit_restaurant">
                            <!-- tab 1 -->
                            <v-tab-item>
                                <v-row dense>

                                    <v-col cols="12" sm="6" md="6">
                                        <v-text-field
                                            clear-icon="mdi-close"
                                            clearable
                                            outlined
                                            label="Restaurant Name*"
                                            hint="enter restaurant name"
                                            required
                                            v-model="name"
                                            :error-messages="nameErrors"
                                            @input="$v.name.$touch()"
                                            @blur="$v.name.$touch()"
                                        ></v-text-field>
                                    </v-col>

                                    <v-col cols="12" sm="6" md="6">
                                        <v-text-field
                                            clear-icon="mdi-close"
                                            clearable
                                            outlined
                                            label="Contact Name*"
                                            hint="enter a contact name"
                                            v-model="contactName"
                                            :error-messages="contactNameErrors"
                                            required
                                            @input="$v.contactName.$touch()"
                                            @blur="$v.contactName.$touch()"
                                        ></v-text-field>
                                    </v-col>

                                    <v-col cols="12" sm="12" md="12">
                                        <v-text-field
                                            append-icon="mdi-magnify"
                                            clear-icon="mdi-close"
                                            clearable
                                            outlined
                                            label="Address*"
                                            hint="type something to search"
                                            v-model="address"
                                            persistent-hint
                                            required
                                            :error-messages="addressErrors"
                                            @input="$v.address.$touch()"
                                            @blur="$v.address.$touch()"
                                            @change="onAddressChanged()"
                                        ></v-text-field>
                                    </v-col>
        <!-- 
                                    <v-col cols="12" sm="5" md="3">
                                        <v-text-field
                                                clear-icon="mdi-close"
                                                clearable
                                                outlined
                                                label="Postcode"
                                                hint="Enter postcode"
                                                v-model="postcode"
                                        ></v-text-field>
                                    </v-col> -->

                                    <v-col cols="12" sm="12" md="12">
                                        <h2 v-if="gmap_results.length != 0">Seach results:</h2>
                                        <h3 v-if="gmap_loading">Seaching address...</h3>
                                        <v-list-item-group color="primary">
                                            <v-list-item
                                                v-for="(item, i) in gmap_results"
                                                :key="i"
                                                @click="onSelectAddress(item)"
                                            >
                                                <v-list-item-icon class="driver-profile_icon">
                                                    <v-icon>mdi-map-marker</v-icon>
                                                </v-list-item-icon>
                                                <v-list-item-content>
                                                    <v-list-item-title v-html="item.formatted_address"></v-list-item-title>
                                                    <!-- <v-list-item-subtitle>sub</v-list-item-subtitle> -->
                                                </v-list-item-content>
                                            </v-list-item>
                                        </v-list-item-group>
                                    </v-col>

                                    <v-col cols="12" sm="12" md="12">
                                        <GmapMap
                                            ref="mapRef"
                                            :options="{
                                                zoomControl: true,
                                                mapTypeControl: false,
                                                scaleControl: true,
                                                streetViewControl: false,
                                                rotateControl: false,
                                                fullscreenControl: true,
                                                disableDefaultUi: false
                                            }"
                                            :center="map_center"
                                            :zoom="map_zoom"
                                            map-type-id="terrain"
                                            style="width: 100%; height: 220px"
                                            @click="onChangeMarkerPosition"
                                        >
                                            <GmapMarker v-if="map_marker" :position="map_marker" />
                                        </GmapMap>
                                    </v-col>

                                    <v-col cols="12" sm="6">
                                        <v-combobox
                                            clear-icon="mdi-close"
                                            clearable
                                            outlined
                                            label="Restaurant Email*"
                                            required
                                            v-model="email"
                                            :error-messages="emailErrors"
                                            item-text="email"
                                            item-value="email"
                                            :items="restaurateurs"
                                            @input="$v.email.$touch()"
                                            @input.native="email=$event.srcElement.value"
                                            @blur="$v.email.$touch()"
                                            @change="onSelectEmail"
                                        ></v-combobox>
                                    </v-col>
                                    <v-col cols="12" sm="6">
                                        <v-combobox
                                            clear-icon="mdi-close"
                                            clearable
                                            outlined
                                            label="Restaurant Business Email*"
                                            required
                                            v-model="business_email"
                                            :error-messages="businessEmailErrors"
                                            @input="$v.email.$touch()"
                                            @input.native="business_email=$event.srcElement.value"
                                            @blur="$v.email.$touch()"
                                        ></v-combobox>
                                    </v-col>

                                    <v-col cols="12" sm="6">
                                        <v-text-field
                                            clear-icon="mdi-close"
                                            clearable
                                            outlined
                                            label="Telephone Number*"
                                            type="Telephone"
                                            v-model="telephone"
                                            required
                                            :error-messages="telephoneErrors"
                                            @change="$v.telephone.$touch()"
                                            @blur="$v.telephone.$touch()"
                                        ></v-text-field>
                                    </v-col>

                                    <v-col cols="12" sm="6" class="pb-0">
                                        <v-select
                                            :readonly="readOnly"
                                            :disabled="readOnly"
                                            outlined
                                            label="Area Assigned to*"
                                            required
                                            v-model="area"
                                            :items="areasList"
                                            item-text="name"
                                            item-value="id"
                                            :error-messages="selectErrors"
                                            @change="onSelectArea"
                                            @blur="$v.area.$touch()"
                                        ></v-select>
                                    </v-col>

                                    <v-col v-if="this.area !== null" sm="12" class="pb-0">
                                        <v-row dense>
                                            <v-col cols="12" sm="6" style="height: 80px"
                                                class="d-flex flex-column justify-space-between pa-0 pr-3">
                                                <span class="adjustment-type">Mon – Thurs Pay/Hr*</span>
                                                <!--<span class="adjustment">$200</span>-->
                                                <div class="adjustment">
                                                <!-- <span class="currency">&#163</span>-->
                                                    <v-text-field
                                                        prefix="£"
                                                        v-model="standard_pay"
                                                        type="number"
                                                        outlined
                                                        class="adjustment-input"
                                                        :placeholder="areaData.standardPayRate"
                                                    ></v-text-field>
                                                </div>
                                            </v-col>

                                            <v-col cols="12" sm="6" style="height: 80px"
                                                class="d-flex flex-column justify-space-between pa-0 pl-3">
                                                <span class="adjustment-type">Fri-Sun Pay/Hr*</span>
                                                <div class="adjustment">
                                                    <v-text-field
                                                        prefix="£"
                                                        v-model="weekend_pay"
                                                        type="number"
                                                        outlined
                                                        class="adjustment-input"
                                                        :placeholder="areaData.weekendPayRate"
                                                    ></v-text-field>
                                                </div>
                                            </v-col>
                                        </v-row>
                                    </v-col>

                                    <v-col cols="12" sm="6">
                                        <v-col cols="12" style="height: 80px"
                                            class="d-flex flex-column justify-space-between pa-0">
                                            <span class="adjustment-type">Dream Drivers Сommission</span>
                                            <div class="adjustment">
                                                <v-text-field
                                                    prefix="%"
                                                    v-model="invoice_comission"
                                                    type="number"
                                                    outlined
                                                    class="adjustment-input"
                                                    :placeholder="default_comission"
                                                    persistent-hint
                                                ></v-text-field>
                                            </div>
                                        </v-col>
                                    </v-col>
                                    <v-col cols="12" sm="6">
                                        <v-col cols="12" style="height: 80px"
                                            class="d-flex flex-column justify-space-between pa-0">
                                            <span class="adjustment-type">Booking fee</span>
                                            <div class="adjustment">
                                                <v-text-field
                                                    prefix="£"
                                                    v-model="booking_fee"
                                                    type="number"
                                                    outlined
                                                    class="adjustment-input"
                                                    :placeholder="default_booking_fee"
                                                    persistent-hint
                                                ></v-text-field>
                                            </div>
                                        </v-col>
                                    </v-col>
                                    <v-col cols="12" sm="3">
                                        <v-col cols="12" style="height: 80px"
                                            class="d-flex flex-column justify-space-between pa-0">
                                            <span class="adjustment-type">Send Invoice</span>
                                            <v-checkbox
                                                v-model="send_invoice"
                                                :true-value="1"
                                                :false-value="0"
                                                :label="`Yes`"
                                        ></v-checkbox>
                                        </v-col>
                                    </v-col>
                                    <v-col cols="12" sm="12">
                                        <v-switch v-model="switch_change_password" :label="`Special Password`"></v-switch>
                                    </v-col>

                                    <v-col cols="12" sm="12" v-if="switch_change_password">
                                        <v-text-field
                                            :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                                            :type="showPassword ? 'text' : 'password'"
                                            @click:append="showPassword = !showPassword"
                                            clear-icon="mdi-close"
                                            clearable
                                            outlined
                                            name="password"
                                            label="Password"
                                            v-model="password"
                                            :rules="passwordRules"
                                            :counter="12"
                                        ></v-text-field>
                                    </v-col>

                                </v-row>
                            </v-tab-item>
                            <!--/ tab 1 -->
                            <!-- tab 2 -->
                            <v-tab-item>
                                <v-row dense>
                                    <v-col cols="12" sm="12">
                                        <v-file-input
                                            :rules="imgRules"
                                            accept="image/png, image/jpeg, image/jpg, image/bmp"
                                            placeholder="Upload a file"
                                            prepend-icon="mdi-camera"
                                            label="File"
                                            ref="image"
                                            @change="onChangeFileUpload"
                                        ></v-file-input>
                                    </v-col>

                                    <v-col cols="12" sm="12" md="12">
                                        <v-text-field
                                            clear-icon="mdi-close"
                                            clearable
                                            outlined
                                            label="Meal"
                                            hint="enter meal"
                                            v-model="meal"
                                            :error-messages="mealErrors"
                                            @input="$v.meal.$touch()"
                                            @blur="$v.meal.$touch()"
                                        ></v-text-field>
                                    </v-col>

                                    <v-col cols="12" sm="12" md="12">
                                        <v-text-field
                                            clear-icon="mdi-close"
                                            clearable
                                            outlined
                                            label="Uniform"
                                            hint="enter uniform"
                                            v-model="uniform"
                                            :error-messages="uniformErrors"
                                            required
                                            @input="$v.uniform.$touch()"
                                            @blur="$v.uniform.$touch()"
                                        ></v-text-field>
                                    </v-col>

                                    <v-col cols="12" sm="12" md="12">
                                        <v-text-field
                                            clear-icon="mdi-close"
                                            clearable
                                            outlined
                                            label="Cash Orders"
                                            hint="enter cash orders"
                                            v-model="cash_orders"
                                            :error-messages="cash_ordersErrors"
                                            required
                                            @input="$v.cash_orders.$touch()"
                                            @blur="$v.cash_orders.$touch()"
                                        ></v-text-field>
                                    </v-col>

                                    <v-col cols="12" sm="12" md="12">
                                        <v-text-field
                                            clear-icon="mdi-close"
                                            clearable
                                            outlined
                                            label="Waiting location"
                                            hint="enter waiting location"
                                            v-model="waiting_location"
                                            :error-messages="waiting_locationErrors"
                                            required
                                            @input="$v.waiting_location.$touch()"
                                            @blur="$v.waiting_location.$touch()"
                                        ></v-text-field>
                                    </v-col>

                                    <v-col cols="12" sm="12" md="12">
                                        <v-text-field
                                            clear-icon="mdi-close"
                                            clearable
                                            outlined
                                            label="Other"
                                            hint="enter other"
                                            v-model="other"
                                            :error-messages="otherErrors"
                                            required
                                            @input="$v.other.$touch()"
                                            @blur="$v.other.$touch()"
                                        ></v-text-field>
                                    </v-col>

                                    <v-col cols="12" sm="12" md="12">
                                        <v-text-field
                                            clear-icon="mdi-close"
                                            clearable
                                            outlined
                                            label="Bonus Target"
                                            hint="enter Bonus Target"
                                            v-model="bonus_target"
                                            :error-messages="bonus_targetErrors"
                                            required
                                            @input="$v.bonus_target.$touch()"
                                            @blur="$v.bonus_target.$touch()"
                                        ></v-text-field>
                                    </v-col>
                                </v-row>
                            </v-tab-item>
                            <!--/ tab 2 -->
                        </v-tabs-items>

                        <div class="d-flex justify-center">
                            <v-btn
                                    depressed
                                    class="mr-4 primary"
                                    :disabled="this.$v.$invalid || localLoading"
                                    :loading="localLoading"
                                    @click="submit"
                            ><v-icon left>mdi-upload</v-icon>Send Verification</v-btn>
                            <v-btn
                                    class="warning"
                                    :loading="localLoading"
                                    depressed
                                    @click="clear"
                            ><v-icon left>mdi-cancel</v-icon>Clear</v-btn>
                        </div>

                    </v-form>
                </v-container>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
    import { validationMixin } from 'vuelidate'
    import { required,/* maxLength,*/ email, /*numeric*/ } from 'vuelidate/lib/validators'
    import axios from 'axios'
    import {mapGetters} from 'vuex'
    import {gmapApi} from 'vue2-google-maps'
    import * as _ from 'lodash'

    const DEFAULT_MAP_CENTER = {lat:51.4, lng:0}; // default London

    export default {
        mixins: [validationMixin],
        name: "NewLocationModal",
        props: ['thisAreaData'],
        validations: {
            name: { required,/* maxLength: maxLength(10)*/ },
            email: { required, email },
            business_email: { required, email },
            telephone: {required, /*numeric*/},
            contactName: { required },
            area: { required },
            address: { required },
            standard_pay: { /*numeric*/ },
            weekend_pay: { /*numeric*/ },
            booking_fee: { /*numeric*/ },
            invoice_comission: { /*numeric*/ },
            meal: {},
            uniform: {},
            cash_orders: {},
            waiting_location: {},
            other: {},
            bonus_target: {},
        },
        data: () => ({
            switch_change_password: false,
            showPassword: false,
            passwordRules: [
                v => !!v || 'Please enter your password',
                v => (v && v.length >= 6) || 'Password should be at least six symbols long'
            ],
            /*valid: false,*/
            readOnly: false,
            localLoading: false,
            dialog: false,
            name: '',
            email: '',
            business_email: '',
            address: '',
            map_latitude: void 0,
            map_longitude: void 0,
            contactName: '',
            telephone: '',
            postcode: '',
            area: null,
            areaData: null,
            password: '',
            standard_pay: null,
            weekend_pay: null,
            invoice_comission: null,
            booking_fee: null,
            send_invoice: 1,
            // areasList: []
            map_center: DEFAULT_MAP_CENTER, // default: London
            map_zoom: 12,
            map_marker: void 0,
            gmap_results: [],
            gmap_loading: false,
            tab_edit_restaurant: void 0,
            default_comission: void 0,
            default_booking_fee: void 0,
            // tab2 fields:
            meal: void 0,
            uniform: void 0,
            cash_orders: void 0,
            waiting_location: void 0,
            other: void 0,
            bonus_target: void 0,
            file: void 0,
            imgRules: [
                value => {
                    if (value && value.size > 10000000) {
                        return 'File size should be less than 10 MB!';
                    }
                    return true;
                }
            ],
            logo_src: void 0
        }),
        created(){
            // --
        },
        updated(){
            if (this.thisAreaData) {
                this.areaData = _.find(this.areas, p => p.id == this.thisAreaData.id);
                this.area = this.areaData
                this.readOnly = true
            }

            // setup map default center
            if (!this.$data.dialog) {
                this.is_initialized = false;
                return; // exit dialog closed
            }

            if (this.is_initialized) {
                return;
            }

            let me = this;
            let timerId = setInterval(() => { // await while google load scripts
                clearInterval(timerId);
                this.is_initialized = true;
            
                let option = _.find(me.options, p => p.okey == 'map_center_default');
                let map_options = JSON.parse(option.ovalue);

                me.map_center = {
                    lat: map_options.lat,
                    lng: map_options.lng
                };
                me.map_zoom = map_options.map_zoom;
                
                // setup default comission
                let default_comission = _.find(me.options, p => p.okey == 'restaurants_standard_invoice_comission');
                if (default_comission && default_comission.ovalue) {
                    me.default_comission = default_comission.ovalue
                }
                // setup default booking fee
                let default_booking_fee = _.find(me.options, p => p.okey == 'restaurants_standard_booking_fee');
                if (default_booking_fee && default_booking_fee.ovalue) {
                    me.default_booking_fee = default_booking_fee.ovalue
                }
            }, 10);
        },
        computed: {
            ...mapGetters([
                'areas',
                'restaurateurs',
                'options',
            ]),
            selectErrors () {
                const errors = [];
                if (!this.$v.area.$dirty) {
                    return errors;
                }
                !this.$v.area.required && errors.push('Area is required');
                return errors
            },
            nameErrors () {
                const errors = [];
                if (!this.$v.name.$dirty) {
                    return errors;
                }
                /*!this.$v.name.maxLength && errors.push('Name must be at most 10 characters long')*/
                !this.$v.name.required && errors.push('Restaurant name is required.')
                return errors
            },
            contactNameErrors () {
                const errors = [];
                if (!this.$v.contactName.$dirty) {
                    return errors;
                }
                !this.$v.contactName.required && errors.push('Contact Name is required.');
                return errors
            },
            emailErrors () {
                const errors = [];
                if (!this.$v.email.$dirty) {
                    return errors;
                }
                !this.$v.email.email && errors.push('Must be valid e-mail');
                !this.$v.email.required && errors.push('E-mail is required');
                return errors
            },
          businessEmailErrors () {
                const errors = [];
                if (!this.$v.business_email.$dirty) {
                    return errors;
                }
                !this.$v.email.email && errors.push('Must be valid e-mail');
                !this.$v.email.required && errors.push('Business E-mail is required');
                return errors
            },
            addressErrors () {
                const errors = [];
                if (!this.$v.address.$dirty) return errors
                !this.$v.address.required && errors.push('Address is required');
                return errors
            },
            telephoneErrors () {
                const errors = [];
                if (!this.$v.telephone.$dirty) {
                    return errors;
                }
                !this.$v.telephone.required && errors.push('Telephone number is required');
                return errors
            },
            areasList() {
                return this.areas;
            },
            mealErrors() {
                const errors = []
                if (!this.$v.meal.$dirty) return errors
                // !this.$v.meal.required && errors.push('Meal is required.')
                return errors
            },
            uniformErrors() {
                const errors = []
                if (!this.$v.uniform.$dirty) return errors
                // !this.$v.uniform.required && errors.push('Uniform is required.')
                return errors
            },
            cash_ordersErrors() {
                const errors = []
                if (!this.$v.cash_orders.$dirty) return errors
                // !this.$v.cash_orders.required && errors.push('Cash Orders is required.')
                return errors
            },
            waiting_locationErrors() {
                const errors = []
                if (!this.$v.waiting_location.$dirty) return errors
                // !this.$v.waiting_location.required && errors.push('Waiting location is required.')
                return errors
            },
            otherErrors() {
                const errors = []
                if (!this.$v.other.$dirty) return errors
                // !this.$v.other.required && errors.push('Other is required.')
                return errors
            },
            bonus_targetErrors() {
                const errors = []
                if (!this.$v.bonus_target.$dirty) return errors
                // !this.$v.bonus_target.required && errors.push('Bonus Target is required.')
                return errors
            },
            google: gmapApi,
        },

        methods: {
            onSelectArea (val) {
                Object.keys(this.areas).forEach(key => {
                    if (this.areas[key].id === val) {
                        this.areaData = this.areas[key]
                    }
                })
            },
            onAddressChanged() {
                if (!this.$data.address) {
                    return;
                }

                this.gmap_loading = true;
                let searchStr = encodeURI(this.$data.address.split(' ').join('+'));
                axios.get(`https://maps.googleapis.com/maps/api/geocode/json?address=${searchStr}&key=${this.appConfig.GOOGLE_MAP_API_KEY}&language=en`)
                    .then(result => {
                        this.gmap_loading = false;
                        this.$data.gmap_results = result.data && result.data.results;
                    });
            },
            onSelectAddress(item) {
                this.address = item.formatted_address;

                let postal_code = _.find(item.address_components, (p) => p.types.indexOf('postal_code') !== -1);
                if (postal_code) {
                    this.postcode = postal_code.short_name;
                }
                
                this.map_latitude = _.get(item, 'geometry.location.lat', void 0);
                this.map_longitude = _.get(item, 'geometry.location.lng', void 0);

                if (this.map_latitude && this.map_longitude) {
                    this.onUpgradeMapMarker();
                }
            },
            onUpgradeMapMarker() {
                let me = this;

                me.$data.map_marker = void 0;
                if (!me.map_latitude || !me.map_longitude) {
                    return;
                }

                me.$refs.mapRef.$mapPromise.then((map) => {
                    me.$data.map_marker = new me.google.maps.LatLng(
                        me.map_latitude,
                        me.map_longitude
                    );

                    var bounds = new me.google.maps.LatLngBounds();
                    bounds.extend(me.$data.map_marker);
                    
                    map.setCenter(bounds.getCenter()); //or use custom center
                    map.setZoom(me.map_zoom);
                });
            },
            onChangeMarkerPosition(marker) {
                if (this.map_latitude || this.map_longitude) {
                    this.map_latitude = void 0;
                    this.map_longitude = void 0;
                } else {
                    this.map_latitude = marker.latLng.lat();
                    this.map_longitude = marker.latLng.lng();
                }

                this.onUpgradeMapMarker();
            },
            onSelectEmail(val) {
                if (typeof val == "object") {
                    this.email = val.email;
                }
            },
            onChangeFileUpload(file){
                this.file = file;
            },
            submit () {
                let user = JSON.parse(localStorage.getItem("user"));
                this.localLoading = true;
                this.$v.$touch();
                if (!this.$v.$invalid){
                    const newRestaurant = {
                        name: this.name,
                        email: this.email,
                        business_email: this.business_email,
                        address: this.address,
                        contactName: this.contactName,
                        telephone: this.telephone,
                        postcode: this.postcode,
                        areaId: this.areaData.id,
                        area: this.areaData,
                        standard_pay: this.standard_pay,
                        weekend_pay: this.weekend_pay,
                        invoice_comission: this.invoice_comission,
                        booking_fee: this.booking_fee,
                        send_invoice: this.send_invoice,
                        map_latitude: this.map_latitude,
                        map_longitude: this.map_longitude,
                        meal: this.meal,
                        uniform: this.uniform,
                        cash_orders: this.cash_orders,
                        waiting_location: this.waiting_location,
                        other: this.other,
                        bonus_target: this.bonus_target,
                    };

                    if (this.switch_change_password) {
                        newRestaurant.password = this.password;
                    }

                    // send file
                    let formData = new FormData();
                    formData.append('file', this.file);

                    _.each(newRestaurant, (val, key) => {
                        formData.append(key, val);
                    });

                    for (var key of formData.keys()) {
                        if (formData.get(key) == null || formData.get(key) == "null") { //?wtf null converts to string "null"
                            formData.delete(key); // -> void 0
                        }
                    }

                    this.$store.dispatch('createNewRestaurant', formData)
                        .then(data => {
                            // send email to restaurant, wtf? via ajax request?
                            data.restCredentials['link'] = `${this.appConfig.app_url}`;
                            axios.post(`${this.appConfig.app_url}/api/sendEmail`, data.restCredentials, {
                                headers: {
                                    'X-Requested-With' : 'XMLHttpRequest',
                                    "Authorization": `Bearer ${user.access_token}`
                                },
                            }).then(email => {
                                console.log(email);
                            });
                        })
                        .finally(() => {
                            this.localLoading = false;
                            this.dialog = false;
                            this.clear();
                        })
                }
            },
            clear () {
                this.$v.$reset();
                this.name = '';
                this.email = '';
                this.business_email = '';
                this.contactName = '';
                this.address = '';
                this.telephone = '';
                this.postcode = '';
                this.area = null;
                this.areaData = {};
                this.standard_pay = null;
                this.weekend_pay = null;
                this.invoice_comission = null;
                this.booking_fee = null;
                this.send_invoice = 1;
                this.map_latitude = void 0;
                this.map_longitude = void 0;

                this.meal = void 0;
                this.uniform = void 0;
                this.cash_orders = void 0;
                this.waiting_location = void 0;
                this.other = void 0;
                this.bonus_target = void 0;
                this.logo_src = void 0;
                                    
            },
        },
    }
</script>

<style scoped>

</style>
